export default __webpack_public_path__ + "static/media/fi-rr-marker.fb7abc51.svg";